import { Badge, Title } from "@mantine/core";
import { IconCalendar } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

interface ReportHeaderProps {
  generatedAt: string;
  totalItems: number;
  onExportPdf: () => void;
  isExporting: boolean;
}

const ReportHeader = ({ generatedAt, totalItems, onExportPdf, isExporting }: ReportHeaderProps) => {
  const { t } = useTranslation();
  const formattedDate = new Date(generatedAt).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  });

  return (
    <div className="flex items-center justify-between">
      <div className="flex flex-col gap-2">
        <Title order={2} className="font-bold text-gray-900">
          {t("reports.inventoryScan.title")}
        </Title>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1 text-sm text-gray-500">
            <IconCalendar size={14} />
            <span>{formattedDate}</span>
          </div>
          <Badge variant="light" color="gray" size="sm">
            {t("reports.inventoryScan.totalItems", { count: totalItems })}
          </Badge>
          <Badge variant="light" color="blue" size="sm">
            {t("reports.inventoryScan.allTimestampsUtc")}
          </Badge>
        </div>
      </div>
      <button
        data-export-button
        onClick={onExportPdf}
        disabled={isExporting}
        className="flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-800 disabled:opacity-50"
      >
        {isExporting ? t("reports.inventoryScan.exporting") : t("reports.inventoryScan.exportPdf")}
      </button>
    </div>
  );
};

export default ReportHeader;
